import { AddOns, SelectablePlans, SelectedAddOns } from '../../types/billing';
import { AddOnPromoDetails, BillItem } from '../../web-shared/types/billing';

export interface BillingState {
  addOns: AddOns;
  addOnPromoDetails: AddOnPromoDetails;
  billingErrorMessage: string;
  canProvidePayment: boolean;
  hasAgreedToSignupTerms: boolean;
  hasAgreedToPaymentTerms: boolean;
  isAuthenticated: boolean;
  isFASTSignUp?: boolean;
  isLinkedOffer: boolean;
  isLoadingPackageDetails: boolean;
  isLoadingSubscriptionStart: boolean;
  isSubscribed: boolean;
  launchChannelId: string;
  launchShowId: string;
  needsValidPaymentInfo: boolean;
  offer: string;
  packageDetailsAreLoaded: boolean;
  promotionalItems: BillItem[];
  selectablePlans: SelectablePlans;
  selectedAddOns: SelectedAddOns;
  signupStep?: number;
  showSubscriptionCodeField: boolean;
  subscriptionCodeInput: string;
  zipCode: string;
}

const initialState: BillingState = {
  addOns: [],
  addOnPromoDetails: {
    endDate: '',
    duration: 0,
    unit: '',
  },
  billingErrorMessage: '',
  canProvidePayment: false,
  hasAgreedToSignupTerms: false,
  hasAgreedToPaymentTerms: false,
  isAuthenticated: false,
  isLinkedOffer: false,
  isLoadingPackageDetails: false,
  isLoadingSubscriptionStart: false,
  isSubscribed: false,
  launchChannelId: '',
  launchShowId: '',
  needsValidPaymentInfo: true,
  offer: '',
  packageDetailsAreLoaded: false,
  promotionalItems: [],
  selectablePlans: [],
  selectedAddOns: [],
  showSubscriptionCodeField: false,
  subscriptionCodeInput: '',
  zipCode: '',
};

export default initialState;
